"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isSet = function isSet(obj) {
  return obj instanceof Set;
};

var _default = isSet;
exports["default"] = _default;